export const FILTER_TYPE = {
  US: 'us',
  ALL_LOCATIONS: 'all_locations',
  INTERNATIONAL: 'international',
  CLUB: 'club',
};

export const MAP_CENTER = {
  US: {
    large_screen: { lat: 37.0902, lng: -95.7129, zoom: 5 },
    small_screen: { lat: 37.0902, lng: -95.7129, zoom: 3.5 },
  },
  ALL_LOCATIONS: {
    large_screen: { lat: 41.154128, lng: -8.604789, zoom: 3 },
    small_screen: { lat: 41.154128, lng: -8.604789, zoom: 3.5 },
  },
  CLUB: {
    large_screen: { lat: 40.994282, lng: -46.275476, zoom: 3 },
    small_screen: { lat: 37.0902, lng: -95.7129, zoom: 3.5 },
  },
  INTERNATIONAL: {
    large_screen: { lat: 45.531705, lng: 9.596625, zoom: 3 },
    small_screen: { lat: 45.531705, lng: 9.596625, zoom: 3.5 },
  },
};
